<template>
  <div class="interview-layout">
    <slot name="header" />
    <slot />
    <slot name="footer" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({})
</script>

<style lang="postcss">
.interview-layout {
  display: grid;
  grid-template-rows: 1fr 18fr 1fr;
  height: 100%;
  overflow: hidden;
}
</style>
